var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSect2Dots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 194,
    viewBox: "0 0 130 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 128.243 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 107.162 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0811,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 86.0811 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.0001,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 65.0001 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 43.919 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8375,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 22.8375 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 1.75675,
    r: 1.75675,
    transform: "rotate(90 1.75692 1.75675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 128.243 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 107.162 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0811,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 86.0811 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 64.9996 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9185,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 43.9185 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8375,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 22.8375 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 22.8388,
    r: 1.75675,
    transform: "rotate(90 1.75692 22.8388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 128.243 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.161,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 107.161 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0807,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 86.0807 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 64.9996 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 43.919 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8375,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 22.8375 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 43.9169,
    r: 1.75675,
    transform: "rotate(90 1.75692 43.9169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 128.243 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 107.162 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0807,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 86.0807 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 64.9996 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 43.919 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.838,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 22.838 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 64.9989,
    r: 1.75675,
    transform: "rotate(90 1.75692 64.9989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 128.243 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 107.162 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0811,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 86.0811 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 64.9996 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 43.919 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.838,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 22.838 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75741,
    cy: 86.081,
    r: 1.75675,
    transform: "rotate(90 1.75741 86.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 128.243 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 107.162 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0811,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 86.0811 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.0001,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 65.0001 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 43.919 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8375,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 22.8375 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 107.163,
    r: 1.75675,
    transform: "rotate(90 1.75692 107.163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 128.243 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 107.162 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0811,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 86.0811 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 64.9996 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9185,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 43.9185 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8375,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 22.8375 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 128.241,
    r: 1.75675,
    transform: "rotate(90 1.75692 128.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 128.243 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.163,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 107.163 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0807,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 86.0807 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 64.9996 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 43.919 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8375,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 22.8375 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 149.323,
    r: 1.75675,
    transform: "rotate(90 1.75692 149.323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 128.243 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 107.162 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0807,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 86.0807 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 64.9996 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 43.919 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.838,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 22.838 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75692,
    cy: 170.405,
    r: 1.75675,
    transform: "rotate(90 1.75692 170.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.243,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 128.243 191.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.162,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 107.162 191.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0811,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 86.0811 191.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 64.9996 191.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.919,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 43.919 191.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.838,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 22.838 191.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75741,
    cy: 191.487,
    r: 1.75675,
    transform: "rotate(90 1.75741 191.487)",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSect2Dots);
export default __webpack_public_path__ + "static/media/sect2-dots.671519f8ad964f6600c78da062a88bda.svg";
export { ForwardRef as ReactComponent };